/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingigreelhint3Inputs */

const en_crosspostingigreelhint3 = /** @type {(inputs: Crosspostingigreelhint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vertical video (9:16).`)
};

const de_crosspostingigreelhint3 = /** @type {(inputs: Crosspostingigreelhint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vertikales Video (9:16).`)
};

/**
* | output |
* | --- |
* | "Vertical video (9:16)." |
*
* @param {Crosspostingigreelhint3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingigreelhint3 = /** @type {((inputs?: Crosspostingigreelhint3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingigreelhint3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingigreelhint3(inputs)
	return de_crosspostingigreelhint3(inputs)
});
export { crosspostingigreelhint3 as "crosspostingIgReelHint" }